// src/pages/Servicos.jsx
import React from 'react';
import Navbar from '@/pages/Navbar/Navbar';
import Rodape from '@/pages/Rodape/Rodape';

import ar from '@/assets/cadeiras.webp';
import sofa from '@/assets/sofa.jpg';
import impermeabilizacao from '@/assets/colchao.jpg';

export default function Servicos() {
  return (
    <>
      <Navbar />

      <section className="bg-white py-20 px-4 text-gray-800">
        <div className="max-w-7xl mx-auto">
<h2
  className="text-[40px] font-[600] text-center text-[#3b2e2e] mb-4"
  style={{ fontFamily: "'Montserrat', sans-serif" }}
>
  SERVIÇOS
</h2>
          <p className="text-center text-lg text-gray-700 mb-12">
            A prestação de nossos serviços é realizada com os mais novos e modernos equipamentos do mercado, visando sempre a qualidade
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Card 1 */}
            <div className="bg-white border rounded-lg shadow-md overflow-hidden">
              <img src={ar} alt="Higienização em cadeiras" className="w-full h-60 object-cover" />
              <div className="p-6">
<h3 className="font-bold text-lg mb-2">Higienização em Cadeiras</h3>
<p className="text-gray-700 text-sm text-justify">
  A higienização de cadeiras é fundamental para garantir ambientes mais saudáveis, confortáveis e visualmente agradáveis. Removemos sujeiras, ácaros e bactérias que se acumulam com o uso diário, contribuindo para o bem-estar dos usuários e a valorização do espaço, seja em residências, escritórios ou ambientes corporativos.
</p>

              </div>
            </div>

            {/* Card 2 */}
            <div className="bg-white border rounded-lg shadow-md overflow-hidden">
              <img src={sofa} alt="Limpeza de Sofás" className="w-full h-60 object-cover" />
              <div className="p-6">
                <h3 className="font-bold text-lg mb-2">Higienização Especializada de Sofás</h3>
<p className="text-gray-700 text-sm text-justify">
  Nossos serviços de higienização de sofás unem tecnologia, cuidado e eficiência para proporcionar um ambiente mais limpo e acolhedor. Eliminamos impurezas profundas, odores indesejados e microrganismos, revitalizando o estofado sem comprometer sua integridade. Um toque de renovação e bem-estar para o seu lar ou empresa.
</p>

              </div>
            </div>

            {/* Card 3 */}
            <div className="bg-white border rounded-lg shadow-md overflow-hidden">
              <img src={impermeabilizacao} alt="Impermeabilização de Estofados" className="w-full h-60 object-cover" />
              <div className="p-6">
               <h3 className="font-bold text-lg mb-2">Limpeza e Higienização de Estofados</h3>
<p className="text-gray-700 text-sm text-justify">
  Nossa higienização de estofados alia técnicas modernas e produtos de alta performance para remover sujeiras profundas e agentes nocivos. Utilizamos soluções que protegem as fibras, revitalizam o tecido e criam uma barreira contra líquidos e odores, promovendo conforto, durabilidade e saúde para seu ambiente.
</p>

              </div>
            </div>
          </div>
        </div>
      </section>

      <Rodape />
    </>
  );
}
